import type { CodeString } from '@/consts/codes';
import { assertNever } from '@/utils/assertNever';

import { SettingCategory } from './queries';
import { menuItemsDataSchema, type ApiResponse, type Setting } from './schema';

export const getCategoryKey = (category: SettingCategory): 'favorites' | 'recents' => {
  switch (category) {
    case SettingCategory.Favorites:
      return 'favorites';
    case SettingCategory.Recents:
      return 'recents';
    default:
      return assertNever(`Unhandled SettingCategory`, category);
  }
};

export const buildSettingsQuery = (category: SettingCategory, userId: string | undefined): string => {
  const base = `criteria.Category=${encodeURIComponent(category)}`;
  return userId ? `${base}&criteria.UserId=${encodeURIComponent(userId)}` : base;
};

export const extractFirstSetting = (parsed: ApiResponse<Setting[] | null | undefined>): Setting | undefined =>
  parsed.Data?.[0];

export const parseSettingsData = (dataJson: string): CodeString[] => {
  const parsed = menuItemsDataSchema.safeParse(JSON.parse(dataJson));
  if (!parsed.success) {
    console.error('Invalid data format:', parsed.error);
    return [];
  }
  return parsed.data.MenuItems.map((i) => i.Code);
};
